module.exports = __webpack_public_path__ + "static/img/clear_cookie.3851bddf.png";